import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import * as lx from 'luxon';
import * as lxt from '../node_modules/luxon/src/impl/conversions.js';

import {environment} from './environments/environment';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';


if (environment.production) {
  enableProdMode();
} else {
  // Dirty hack to pass strictStateImmutability check from ngrx
  // Issue on GitHub: https://github.com/moment/luxon/issues/323
  // (https://ngrx.io/guide/store/configuration/runtime-checks).
  Object.defineProperty(lx.DateTime.prototype, 'weekData', {
    enumerable: false,
    get(this: lx.DateTime) {
      return lxt.gregorianToWeek(this);
    },
    set() { }
  });
}

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch(err => console.error(err));
